import React, { Component } from "react";
import {
  Grid,
  Paper,
  Button,
  Divider,
  Select,
  withStyles,
} from "@material-ui/core";
import clsx from "clsx";
import Navi_Buttons from "../../../components/forms/navi_buttons";
import { withRouter } from "react-router-dom";
import { Alert, AlertTitle } from "@material-ui/lab";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ZwitserseFoto from "../../../components/forms/zwitserse_foto";
import shortfetch from "../../../components/data/fetch";
import CopyModelData from "./button_copy";
import AddNewModel from "./button_add_new";
import TransferModel from "./button_omzetten";
import DeleteModel from "./button_delete";
import LoadingBar from "../../../components/data/loading";
import getBase64Image from "../../../components/forms/Base64_Encode";
import WarningBox from "../../../components/forms/warning_Box";
import CreateInput from "../../../components/form_input_fields";
import Inputs from "./Inputs";

const styles = {
  paper: {
    padding: 5,
  },
};

class Form_Modellen_DINH extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data_array: {},
      isLoading: true,
      select_items_list: {},
    };
  }

  async fetch_data(id) {
    let post_json = {
      id: id,
      type: "model_data_DINH",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    console.log("fetched_data", data.data_array);

    this.setState({
      ori_data_array: JSON.stringify(data.data_array),
      data_array: data.data_array,
      isLoading: false,
      select_items_list: data,
    });
  }

  async save_data() {
    let post_json = {
      type: "save_data_DINH",
      data: this.state.data_array,
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    if (!data.geslaagd) {
      alert("Er is iets fout gegaan tijdens het opslaan.");
    }

    await this.fetch_data(this.state.data_array.ModelID);
  }

  async copyImages() {
    let post_json = {
      type: "copy_images_DINH",
      data: this.state.data_array,
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    this.setState({
      isLoading: true,
    });

    await shortfetch(post_json, true);

    this.setState({
      isLoading: false,
    });
  }

  componentDidMount() {
    this.fetch_data(this.props.match.params.id);
  }

  Change_Data(key, value) {
    let new_data_array = this.state.data_array;
    console.log("Key: " + key, "Value:" + value);
    new_data_array[key] = value;
    console.log(new_data_array);
    this.setState({ data_array: new_data_array });
  }

  Create_Input(item) {
    const { name } = item;

    return (
      <React.Fragment key={name}>
        <Grid
          container
          alignItems="center"
          style={{
            overflow: "hidden",
            width: "calc(99% - 5px)",
            padding: 5,
          }}
        >
          <Grid item xs={6}>
            {name + ":"}
          </Grid>
          <Grid item xs={6}>
            <CreateInput
              data={item}
              data_array={this.state.data_array}
              Change_Data={this.Change_Data.bind(this)}
              list={this.state.select_items_list}
            />
          </Grid>
        </Grid>
        <Divider></Divider>
      </React.Fragment>
    );
  }

  Change_State = (someArg) => {
    this.fetch_data(someArg);
    this.setState({ isLoading: true });
  };

  Delete_Image(Type, ID) {
    confirmAlert({
      title: "Foto verwijderen",
      message: `Weet je zeker dat je de ${Type} foto wilt verwijderen?`,
      buttons: [
        {
          label: "Ja",
          onClick: () => {
            let post_json = {
              type: "delete_image_DINH",
              auth: localStorage.getItem("auth"),
              ModelID: ID,
              data: Type,
            };
            console.log(JSON.stringify(post_json));
            fetch("/api/fetch_data.php", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-form-urlencoded",
              },
              body: JSON.stringify(post_json),
            })
              .then((response) => response.json())
              .then((data) => {
                let succes;
                if (data.geslaagd) {
                  succes = "De foto is succesvol verwijderd.";
                } else {
                  succes = "Er is iets fout gegaan tijdens het verwijderen.";
                }
                alert(succes);
              });
          },
        },
        {
          label: "Nee",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingBar />;
    }

    const { classes, className } = this.props;
    const { ModelID, ZwitserseID } = this.state.data_array;
    const NaviButtonsWithRouter = withRouter(Navi_Buttons);
    const CopyModelDataWithRouter = withRouter(CopyModelData);
    const AddNewModelWithRouter = withRouter(AddNewModel);
    const TransferModelWithRouter = withRouter(TransferModel);
    const DeleteModelWithRouter = withRouter(DeleteModel);

    return (
      <div style={{ marginBottom: 250 }}>
        <WarningBox
          ShowError={
            this.state.ori_data_array === JSON.stringify(this.state.data_array)
          }
        />
        <Grid container>
          <Grid item xs={12} container spacing={1}>
            <Grid item xs={2} container justify="center" alignItems="center">
              <Grid item>
                <CopyModelDataWithRouter
                  Change_State={this.Change_State}
                  max={this.state.select_items_list.total}
                  ModelID={this.state.data_array.ModelID}
                />
              </Grid>
            </Grid>
            <Grid item xs={2} container justify="center" alignItems="center">
              <Grid item>
                <AddNewModelWithRouter
                  Change_State={this.Change_State}
                  max={this.state.select_items_list.total}
                  ModelID={this.state.data_array.ModelID}
                />
              </Grid>
            </Grid>
            <Grid item xs={2} container justify="center" alignItems="center">
              <Grid item>
                <Button
                  onClick={() => this.save_data()}
                  style={{ background: "white" }}
                >
                  Opslaan
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <NaviButtonsWithRouter
                value={this.props.match.params.id}
                Change_State={this.Change_State}
                max={this.state.select_items_list.total}
              />
            </Grid>
          </Grid>
          {this.state.data_array.Overgezet_Naar != 0 ? (
            `Dit model is al overgezet naar ${
              this.state.data_array.Overgezet_Naar == -1
                ? "de prullenbak"
                : this.state.data_array.Overgezet_Naar
            }.`
          ) : (
            <Grid style={{ paddingLeft: 8 }} item xs={12} container spacing={1}>
              <Grid item xs={4} container direction="column">
                <Grid item>
                  <Paper className={clsx(classes.paper)}>
                    <h3>Algemeen</h3>
                    <Divider></Divider>
                    {Inputs.AlgemeenArray.map((item) => {
                      return this.Create_Input(item);
                    })}
                  </Paper>
                </Grid>
                <Grid item style={{ marginTop: 8 }}>
                  <Paper className={clsx(classes.paper)}>
                    <h3>Extra</h3>
                    <Divider></Divider>
                    {Inputs.ExtraArray.map((item) => {
                      return this.Create_Input(item);
                    })}
                  </Paper>
                </Grid>
              </Grid>
              <Grid item xs={4} container direction="column">
                <Grid item>
                  <Paper className={clsx(classes.paper)}>
                    <h3>Kenmerken</h3>
                    <Divider></Divider>
                    {Inputs.KenmerkenArray.map((item) => {
                      return this.Create_Input(item);
                    })}
                  </Paper>
                </Grid>
                <Grid item style={{ marginTop: 8 }}>
                  <Paper className={clsx(classes.paper)}>
                    <h3>Set</h3>
                    <Divider></Divider>
                    {Inputs.SetArray.map((item) => {
                      if (
                        item.data_key === "PartOfSet" ||
                        Number(this.state.data_array["PartOfSet"])
                      ) {
                        return this.Create_Input(item);
                      }
                    })}
                  </Paper>
                </Grid>
              </Grid>
              <Grid item xs={4} container direction="column">
                <Grid item>
                  <Paper className={clsx(classes.paper)}>
                    <h3>Kleuren</h3>
                    <Divider></Divider>
                    {Inputs.KleurenArray.map((item) => {
                      return this.Create_Input(item);
                    })}
                  </Paper>
                </Grid>
                <Grid item style={{ marginTop: 8 }}>
                  <Paper className={clsx(classes.paper)}>
                    <h3>Overige</h3>
                    <Divider></Divider>
                    {Inputs.OverigeArray.map((item) => {
                      return this.Create_Input(item);
                    })}
                  </Paper>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Paper className={clsx(classes.paper)}>
                  <h3>Aanhanger/Aanbouwapparaat</h3>
                  <Divider></Divider>
                  <Grid container>
                    {Inputs.AanbouwArray.map((item, index) => {
                      return (
                        <Grid item xs={4} key={index}>
                          {this.Create_Input(item)}
                        </Grid>
                      );
                    })}
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={clsx(classes.paper)}>
                  <h3>Foto's</h3>
                  <Divider></Divider>
                  <Grid container justify="center">
                    {[
                      { name: "RechterZijkant", size: 2 },
                      { name: "LinkerZijkant", size: 2 },
                      { name: "VoorKant", size: 2 },
                      { name: "AchterKant", size: 2 },
                      { name: "BovenKant", size: 2 },
                      { name: "OnderKant", size: 2 },
                      { name: "Algemeen", size: 3 },
                      { name: "Set", size: 3 },
                      { name: "Catalogus", size: 3 },
                    ].map((item) => {
                      return (
                        <Grid
                          item
                          xs={item.size}
                          container
                          alignItems="center"
                          style={{
                            overflow: "auto",
                            width: "calc(100% - 5px)",
                            padding: 5,
                          }}
                          key={item.name}
                        >
                          <img
                            src={
                              `/media/Model_images_DINH/Model-${ModelID}/${ModelID}-${item.name}_min.jpg?` +
                              new Date().getTime()
                            }
                            style={{
                              width: "100%",
                              borderRadius: 7,
                              border: "black 2px solid",
                            }}
                            onClick={(e) => {
                              this.Delete_Image(item.name, ModelID);
                              e.target.src =
                                "/media/Model_images/Placeholder.jpg";
                            }}
                            onError={(e) => {
                              e.target.onError = null;
                              e.target.src =
                                "/media/Model_images/Placeholder.jpg";
                            }}
                          ></img>
                          <Grid item xs={6}>
                            {item.name}
                          </Grid>
                          <Grid item xs={6}>
                            <input
                              type="file"
                              id={"img" + item.name}
                              name={item.name}
                              //value={this.state.data_array[data_key]}
                              style={{
                                width: "100%",
                                fontSize: "120%",
                                display: "none",
                              }}
                              onChange={(e) =>
                                getBase64Image(e.target.files[0]).then(
                                  (value) => this.Change_Data(item.name, value)
                                )
                              }
                            ></input>
                            <label htmlFor={"img" + item.name}>
                              <Button
                                component="span"
                                className={classes.button}
                                style={{
                                  background: "grey",
                                }}
                              >
                                Upload
                              </Button>
                            </label>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Divider></Divider>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={clsx(classes.paper)}>
                  <Grid container justify="center" alignItems="center">
                    <Grid
                      item
                      xs={12}
                      container
                      justify="center"
                      alignItems="center"
                    >
                      <Button
                        onClick={() => this.save_data()}
                        style={{ background: "#D3D3D1", width: "80%" }}
                      >
                        Opslaan
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={clsx(classes.paper)}>
                  <Grid container justify="center" alignItems="center">
                    <Grid
                      item
                      xs={12}
                      container
                      justify="center"
                      alignItems="center"
                    >
                      <span styl={{ fontSize: "150%" }}>Zwitserse foto</span>
                      <Divider />
                    </Grid>
                    <Grid item xs={3}>
                      {ZwitserseID !== "" ? (
                        <ZwitserseFoto link={ZwitserseID} />
                      ) : (
                        "Er is geen zwitserse foto gevonden."
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={7}
                      container
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Button
                          onClick={() => this.copyImages()}
                          style={{ background: "grey" }}
                        >
                          Foto's van Zwiterse downloaden
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className={clsx(classes.paper)}>
                  <Grid container justify="center" alignItems="center">
                    <Grid
                      item
                      xs={12}
                      container
                      justify="center"
                      alignItems="center"
                    >
                      <TransferModelWithRouter
                        Change_State={this.Change_State}
                        ModelID={this.state.data_array.ModelID}
                      />
                      <DeleteModelWithRouter
                        Change_State={this.Change_State}
                        ModelID={this.state.data_array.ModelID}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Form_Modellen_DINH);
